import { gql } from '@apollo/client';

const getSellerInputUuidQuery = gql`
  query GetSellerInputUuidQuery($input: OdProtosWebServicesSellDirect_GetLeadRequestInput!) {
    sellDirect {
      getLead(input: $input) {
        lead {
          sellerInputUuid
        }
      }
    }
  }
`;

export default getSellerInputUuidQuery;
